import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import { BarChart, XAxis, YAxis, ResponsiveContainer, Bar } from 'recharts';
import { Typography } from '@material-ui/core';

// Generate Sales Data
function createData(time: any, amount: any) {
  return { time, amount };
}

const data = [
  createData('01/06', .50),
  createData('02/06', .300),
  createData('03/06', .5),
  createData('04/06', .8),
  createData('05/06', .1500),
  createData('06/06', .2000),
  createData('07/06', .2400),
];

export default function RainfallChart() {
  const theme = useTheme();

  return (
    <React.Fragment>
      <Typography component="h6" variant="h6" color="primary" noWrap>Last 7 days</Typography>
      <ResponsiveContainer>
        <BarChart
          data={data}
          margin={{
            top: 20,
          }}
        >
          <XAxis dataKey="time" stroke={theme.palette.text.secondary} />
          <YAxis stroke={theme.palette.text.secondary}/>
          <Bar dataKey="amount" fill="#8884d8" />
        </BarChart>
      </ResponsiveContainer>
    </React.Fragment>
  );
}